export default "__VITE_ASSET__4vMXilBG__"